<template>
    <div class="flex flex-col gap-[10px] md:gap-[20px]">
        <TitleBlockStat title="Recent Mentions" info-text="all mentions" :info-link="route(`${prefixRoute}.mention.index`)" />

        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-[30px]">
            <div v-for="(column, index) in columns" :key="index" class="flex flex-col gap-[40px]">
                <RecentMentionsItem v-for="mention in column" :key="mention.id" :mention="mention" :prefix-route="prefixRoute" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import TitleBlockStat from '@/Components/BrandMonitoring/TitleBlockStat.vue';
import RecentMentionsItem from '@/Components/BrandMonitoring/Widgets/RecentMentionsItem.vue';

const props = defineProps({
    data: Object,
    prefixRoute: String
});

const columns = ref([[], []]);

onMounted(() => {
    if (
        typeof props.data.recentMentions !== "undefined"
    ) {
        distributeMentions();
    } else {
        console.error("recentMentions is not an array", props.data.recentMentions);
    }
});

function distributeMentions() {
    const mentions = Object.values(props.data.recentMentions);

    mentions.forEach((mention, index) => {
        const columnIndex = index % 2;
        columns.value[columnIndex].push(mention);
    });
}

const colors = [
    'slate', 'gray', 'zinc', 'neutral', 'stone',
    'red', 'orange', 'amber', 'yellow', 'lime',
    'green', 'emerald', 'teal', 'cyan', 'sky',
    'blue', 'indigo', 'violet', 'purple', 'fuchsia',
    'pink', 'rose'
];

const getRandomBackgroundColorClass = (shade = 400) => {
    const randomIndex = Math.floor(Math.random() * colors.length);
    return `bg-${colors[randomIndex]}-${shade}`;
};

</script>